import BaseService from "@/services/BaseService";
import {http} from "./config"

class CrmPropostaService extends BaseService {
  constructor() {
    super("/v1/crm/propostas");
  }

  listar(data){
    const queryParams = `id=${data.id ? data.id : ''}
      &propostaId=${data.propostaId ? data.propostaId : ''}
      &cliente=${data.cliente ? data.cliente : ''}
      &funcionarioId=${data.funcionarioId ? data.funcionarioId : ''}
      &status=${data.status ? data.status : ''}
      &page=${data.page ? data.page : 1}
      &limit=${data.limit ? data.limit : ''}`

      return http.get(`/v1/crm/propostas?${queryParams}`)
  }

  // finalizar(data){
  //   return http.post(`/v1/crm/pos-venda/${data.id}/finalizar`)
  // }
}

export default new CrmPropostaService();
